var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('portal-target',{attrs:{"name":"modal"}}),_c('portal-target',{attrs:{"name":"payment-failed-modal"}}),_c('portal-target',{attrs:{"name":"unavailable-event-modal"}}),_c('portal-target',{attrs:{"name":"magensa-event-details"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }